import React, { useState } from "react";
import "../styles/fixedactionbuttons.css";

const FixedActionButtons = () => {
  const [showPanel, setShowPanel] = useState(false);

  return (
    <div className="body">
      <div className="fixed-action-btn-root">
        {/* Vertical Button */}
        <button
          className="get-in-touch-fixed-btn"
          onClick={() => setShowPanel((v) => !v)}
          aria-label="Get In Touch"
        >
          Get In Touch
        </button>

        {/* Slide-Out Panel */}
        <div className={`contact-slide-panel${showPanel ? " open" : ""}`}>
          <button
            className="slide-panel-close"
            onClick={() => setShowPanel(false)}
            aria-label="Close"
          >
            ×
          </button>
          <div className="slide-panel-content">
            <h2>Let's Connect!</h2>
            <p>We'd love to hear from you.</p>
            <a href="mailto:info@serenityy.ae" className="contact-link">
              info@serenityy.ae
            </a>
            <a href="tel:+97143827715" className="contact-link">
              +971 43827715
            </a>
            <a
              href="/contact"
              className="slide-contact-btn"
              onClick={() => setShowPanel(false)}
            >
              Go to Contact Form
            </a>
          </div>
        </div>
      </div>

      {/* Scroll to Top (always in corner) */}
      <button
        className="scroll-top-fixed-btn"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Scroll to top"
      >
        <svg width="24" height="24" fill="none">
          <path
            d="M12 17V7M12 7l-5 5m5-5l5 5"
            stroke="#888"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default FixedActionButtons;
